<template>
  <div class="login-container">
    <div class="login-box">
      <h2>관리자 로그인</h2>
      <form @submit.prevent="handleLogin">
        <input v-model="form.username" type="text" placeholder="아이디" required />
        <input v-model="form.password" type="password" placeholder="비밀번호" required />
        <button type="submit">로그인</button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import axios from '@/utils/axios';
import router from '@/router'

const form = reactive({
  username: '',
  password: ''
})

const handleLogin = async () => {
  try {
    const res = await axios.post('/bx201/login', form)
    const token = res.data.token

    // 로컬스토리지 또는 쿠키 저장 (여기선 로컬)
    localStorage.setItem('adminToken', token)

    // 어드민 페이지로 이동
    router.push('/admin')

  } catch (e) {
    alert('로그인 실패: 아이디나 비밀번호를 확인하세요')
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.login-box {
  background-color: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 300px;
}

.login-box h2 {
  text-align: center;
  margin-bottom: 24px;
  color: #333;
}

input {
  width: 100%;
  padding: 10px;
  margin-bottom: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
